'use client';

import { useTranslation } from 'react-i18next';

/**
 * Attribution and modification notice for Swiss register data, required by
 * the Swiss registry's terms of reuse: reused data must state its origin
 * (Herkunft) and point out that it may have been modified. Rendered at the
 * bottom of the company page for every CH-HR company — on a Swiss company
 * page all register-derived content (profile, status, shareholders) comes
 * from Zefix/SHAB.
 */
export function SwissDataSourceNote() {
  const { t } = useTranslation();
  return (
    <div className="mt-6 space-y-1 text-xs text-muted-foreground">
      <p>{t('companyDetail.swissSource.attribution')}</p>
      <p>{t('companyDetail.swissSource.modified')}</p>
    </div>
  );
}
